import { FC, useEffect, useState } from 'react';

import { Person as PersonIcon } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';

import { MerchantStatuses } from 'src/constants';

interface MerchantStatProps {
    label: string;
    value: string | number;
}

type Merchant = {
    id: number;
    status: MerchantStatuses;
};

interface MerchantSummaryProps {
    merchants: Merchant[];
}

const MerchantStat: FC<MerchantStatProps> = ({ label, value }) => {
    return (
        <Grid
            md={6}
            sx={{
                display: 'flex',
                placeItems: 'center',
                flexDirection: 'column',
            }}
        >
            <Typography>{label}</Typography>
            <Grid
                sx={{ display: 'flex', flexDirection: 'row', padding: '4px' }}
                alignItems="center"
                gap={1}
            >
                <PersonIcon sx={{ color: '#FDC800' }} />
                <Typography sx={{ fontSize: '24px', fontWeight: 500, color: '#575757' }}>
                    {value}
                </Typography>
            </Grid>
        </Grid>
    );
};

const MerchantSummary: FC<MerchantSummaryProps> = ({ merchants }) => {
    const [activeMerchantsCount, setActiveMerchantsCount] = useState<number>(0);
    const [cancelledMerchantsCount, setCancelledMerchantsCount] = useState<number>(0);

    useEffect(() => {
        if (merchants.length > 0) {
            setActiveMerchantsCount(
                merchants.filter((merchant) => merchant.status === MerchantStatuses.ACTIVE)
                    .length || 0
            );

            setCancelledMerchantsCount(
                merchants.filter((merchant) => merchant.status === MerchantStatuses.CANCELLED)
                    .length || 0
            );
        }
    }, [merchants]);

    return (
        <Grid
            sx={{
                display: 'flex',
                flexDirection: 'row',
                padding: '0 0 12px 0',
            }}
            gap={1}
        >
            <MerchantStat label="Total Active Merchants" value={activeMerchantsCount} />
            <Grid sx={{ borderLeft: '1px solid #FDC800' }} gap={1} />
            <MerchantStat label="Total Cancelled Merchants" value={cancelledMerchantsCount} />
        </Grid>
    );
};

export default MerchantSummary;
